import { addDays, format, isAfter } from 'date-fns';
import { ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';

type ScheduleExpiryReason = 'paymentDate' | 'elinxSettings';

function computeScheduleExpiry(
  paymentDate: Date,
  elinxExpirationDays: number,
): { date: Date; reason: ScheduleExpiryReason } {
  const elinxSettingsExpiry = addDays(new Date(), elinxExpirationDays);

  if (isAfter(paymentDate, elinxSettingsExpiry)) {
    return { date: elinxSettingsExpiry, reason: 'elinxSettings' };
  }

  return { date: paymentDate, reason: 'paymentDate' };
}

export function useScheduleExpiryMessage(paymentDate?: Date, elinxExpirationDays?: number): ReactNode | null {
  const { t } = useTranslation('translations', { keyPrefix: 'UI.ScheduleExpiryBanner' });

  if (!paymentDate || elinxExpirationDays === undefined) return null;

  const { date, reason } = computeScheduleExpiry(paymentDate, elinxExpirationDays);

  if (reason === 'paymentDate') {
    return (
      <Trans
        t={t}
        i18nKey="setByPaymentDate"
        values={{ date: format(date, 'MMMM d, yyyy') }}
        components={{ bold: <strong /> }}
      />
    );
  }

  return (
    <Trans
      t={t}
      i18nKey="setByElinxSettings"
      values={{ days: elinxExpirationDays, date: format(date, 'MMMM d, yyyy') }}
      components={{ bold: <strong /> }}
    />
  );
}
